import { render, staticRenderFns } from "./onlinecourses_details.vue?vue&type=template&id=d4fb796e&scoped=true&"
import script from "./onlinecourses_details.vue?vue&type=script&lang=js&"
export * from "./onlinecourses_details.vue?vue&type=script&lang=js&"
import style0 from "./onlinecourses_details.vue?vue&type=style&index=0&id=d4fb796e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4fb796e",
  null
  
)

export default component.exports